module.exports = __webpack_public_path__ + "static/grace-08d7da8471b21f713763253cd5feede1.jpg";